(function () {
  const root = document.querySelector('[data-site-modals]');
  if (!root) return;

  const modals = Array.from(root.querySelectorAll('.site-modal'));
  if (!modals.length) return;

  const handleToModal = new Map();
  modals.forEach(m => handleToModal.set(m.dataset.modalHandle, m));

  let scrollY = 0;

  /* Open a modal by handle (e.g. 'about') */
  function open(handle) {
    const modal = handleToModal.get(handle);
    if (!modal) return;

    scrollY = window.scrollY;
    document.body.classList.add('modal-lock');
    document.body.style.top = `-${scrollY}px`;

    modal.hidden = false;                   // show it
    requestAnimationFrame(() => {
      modal.classList.add('is-open');      // trigger CSS transition
    });
  }

  /* Close a specific modal element */
  function close(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');     // start transition out
    // IMPORTANT: match this to your CSS transition (250ms in our CSS)
    setTimeout(() => {
      modal.hidden = true;                 // fully hide after animation
      document.body.classList.remove('modal-lock');
      document.body.style.top = '';
      window.scrollTo(0, scrollY);
    }, 250);
  }

  /* Intercept clicks on anchors like #about, #resources, #contact, #shipping */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;

    const hash = (a.getAttribute('href') || '').slice(1).trim(); // remove '#'
    if (!hash || !handleToModal.has(hash)) return;               // not one of our modals

    e.preventDefault();
    open(hash);
  });

  /* Wire close actions per modal (NO delegation pitfalls) */
  modals.forEach(modal => {
    const backdrop = modal.querySelector('[data-modal-backdrop]');
    const closeBtn = modal.querySelector('[data-modal-close]');
    const sheet    = modal.querySelector('.site-modal__sheet');

    // Backdrop closes
    if (backdrop) {
      backdrop.addEventListener('click', () => close(modal));
    }

    // Close button closes (even if you click an inner icon/span)
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        close(modal);
      });
    }

    // Prevent backdrop-click handler from firing when interacting inside the sheet
    if (sheet) {
      sheet.addEventListener('click', (e) => e.stopPropagation());
    }
  });

  /* ESC key closes the first open modal */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const openModal = modals.find(m => !m.hidden);
    if (openModal) close(openModal);
  });

  // Optional: expose helpers for manual triggers
  window.SiteModals = { open, close };
})();
